import React from 'react'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { LicenseAgreement } from '@/components/LicenseAgreement'
import { DBTables } from '../../types/supabaseSugarTypes'
import { configureSubDialogClassName } from '@/components/configureSubDialogClassName'

type Subscription = DBTables['subscriptions']['Row']

export const LicenseAgreementDialog = ({
  subscription,
  open,
  onOpenChange,
}: {
  subscription: Subscription
  open: boolean
  onOpenChange: (open: boolean) => void
}) => {
  const handleAgreed = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={configureSubDialogClassName}>
        <LicenseAgreement userId={subscription.auth_user_id} onAgreed={handleAgreed} />
      </DialogContent>
    </Dialog>
  )
}
